import React from 'react';
import { Bar, Line, Pie, Doughnut, Radar } from 'react-chartjs-2';

const Overview = () => {
    // Sample data for the graphs
    const barChartData = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June'],
        datasets: [
            {
                label: 'Flood Issues',
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
            {
                label: 'Drought Issues',
                data: [8, 15, 10, 6, 3, 8],
                backgroundColor: 'rgba(255, 206, 86, 0.2)',
                borderColor: 'rgba(255, 206, 86, 1)',
                borderWidth: 1,
            },
            {
                label: 'Contamination Issues',
                data: [5, 12, 8, 15, 7, 10],
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 1,
            },
        ],
    };

    const lineChartData = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June'],
        datasets: [
            {
                label: 'Water Quality Index',
                data: [5, 10, 6, 8, 12, 9],
                fill: false,
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 1,
            },
        ],
    };

    const pieChartData = {
        labels: ['Flood', 'Drought', 'Contamination'],
        datasets: [
            {
                data: [40, 30, 30],
                backgroundColor: ['#4CAF50', '#FFC107', '#FF5252'],
                borderWidth: 1,
            },
        ],
    };

    const doughnutChartData = {
        labels: ['Flood', 'Drought', 'Contamination'],
        datasets: [
            {
                data: [40, 30, 30],
                backgroundColor: ['#4CAF50', '#FFC107', '#FF5252'],
                borderWidth: 1,
            },
        ],
    };

    const radarChartData = {
        labels: ['Floods', 'Droughts', 'Contamination', 'Infrastructure', 'Water Quality'],
        datasets: [
            {
                label: 'Water Issues',
                data: [50, 30, 40, 25, 35],
                fill: true,
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
                pointRadius: 3,
                pointBorderColor: 'rgba(75, 192, 192, 1)',
                pointBackgroundColor: '#fff',
            },
        ],
    };

    return (
        <div>
            <div className="flex flex-col items-center justify-center">
                <h1 className="text-4xl font-bold text-gray-800 p-6">Water Disaster Statistics</h1>
                <p className="text-gray-600 p-6">Graphical representation of various water disaster issues and statistics.</p>
                
                <div className="w-[80%] my-4">
                    <Bar data={barChartData} />
                </div>

                <div className="w-[80%] my-4">
                    <Line data={lineChartData} />
                </div>

                <div className="w-[80%] my-4">
                    <Pie data={pieChartData} />
                </div>

                <div className="w-[80%] my-4">
                    <Doughnut data={doughnutChartData} />
                </div>

                <div className="w-[80%] my-4">
                    <Radar data={radarChartData} />
                </div>
            </div>
        </div>
    );
};

export default Overview;
